import { useCallback, useEffect, useState } from 'react';
import {
  Link,
  useParams,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { post } from '../Auths/AuthToken';
import PatientPrgressReport from '../PatientPrgressReport';
import CounselingNoteEdit from './CounselingNoteEdit';
import { DEFAULT_LOCAL_PATH } from '../../constents';
import AddNote from '../Notes/AddNote';
import ViewPhoneNote from '../Notes/ViewPhoneNote';
import ViewAlertPopup from './ViewAlertPopup';
import { useSelector } from 'react-redux';
import setUiMessage from '../../Utilities/Tostify';

function PatientCounselingNote({ patientId }) {
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const { globalReload } = useSelector((state) => state.app);
  const { patAlertData } = useSelector((state) => state.appointment);

  const [allData, setAllData] = useState(null);
  const [dosSerch, setDosSerch] = useState('');
  const [tovSerch, setTovSerch] = useState('');
  const [noteStSerch, setNoteStSerch] = useState('');
  const [provId, setProvIdSerch] = useState('');
  const [provSignSt, setProvStSerch] = useState('');
  const [coSigner, setCoProvIdSerch] = useState('');
  const [coSignerSt, setCoProvStSerch] = useState('');
  const [actionSt, setActionStSerch] = useState('');
  const [serviceCode, setServiceCodeSerch] = useState('');
  const [billSt, setBillStSerch] = useState('');
  const [allOpen, setAllOpen] = useState(0);
  const [allSigned, setAllSigned] = useState(0);
  const { appId, visitId } = useParams();
  const [queryParameters] = useSearchParams();
  const flag = queryParameters.get('flag');

  const [patProgViewPopup, setPatProgViewPopup] = useState(false);
  const [soapId, setSoapId] = useState(false);
  const [appointmentId, setAppointmentId] = useState(false);
  const [phoneNotePopup, setPhoneNotePopup] = useState({
    status: false,
    soapId: 0,
  });
  const [phoneNoteViewPopup, setPhoneNoteViewPopup] = useState({
    status: false,
    soapId: 0,
  });
  const [visit_id, setVisit_id] = useState(false);
  const [alertPopup, setAlertPopup] = useState(false);

  const handleCounPopUpOpen = (soapId, appointmentId, lable, visitId) => {
    setSoapId(soapId);
    const apptId = appId ? appId : appointmentId;
    if (lable === 'Access' || lable === 'View & Sign') {
      setVisit_id(visitId);
      setPatProgViewPopup(true);
      setAppointmentId(apptId);
    } else if (lable === 'Record') {
      navigate(
        `${DEFAULT_LOCAL_PATH}/patient/counNote/${patientId}/${apptId}/${visitId}`,
        {
          replace: true,
        }
      );
    }
  };
  const handleSoapPopUpOpen = (soapId, appointmentId, lable, visitId) => {
    const apptId = appId ? appId : appointmentId;
    setAppointmentId(apptId);
    setSoapId(soapId);
    setVisit_id(visitId);
    setPatProgViewPopup(true);
  };

  const [reload, setReload] = useState(false);
  const handleReload = useCallback(() => {
    setReload(!reload);
  }, [reload]);

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/patient/ProgressNote/counselingNoteList',
          {
            patientId: patientId,
            dos: dosSerch,
            tov: tovSerch,
            noteSt: noteStSerch,
            provId: provId,
            provSignSt: provSignSt,
            coSigner: coSigner,
            coSignerSt: coSignerSt,
            actionSt: actionSt,
            serviceCode: serviceCode,
            billSt: billSt,
            staffUserId: user?.id,
            allOpen,
            allSigned,
          }
        );
        if (response.status === 200) {
          setAllData(response?.data);
        }
      } catch (err) {
        setUiMessage('err', err.message);
      }
    })();
  }, [
    patientId,
    dosSerch,
    tovSerch,
    noteStSerch,
    provId,
    provSignSt,
    coSigner,
    coSignerSt,
    actionSt,
    serviceCode,
    billSt,
    reload,
    user?.id,
    globalReload,
    allOpen,
    allSigned,
  ]);

  useEffect(() => {
    if (allOpen === 0 && allSigned === 0) {
      setAllOpen((prev) => 1);
      setAllSigned((prev) => 1);
    }
  }, [allOpen, allSigned]);

  useEffect(() => {
    if (
      patAlertData?.alertActive?.active_alert_notification === '1' &&
      patAlertData.patientId === patientId
    ) {
      setAlertPopup((prev) => true);
    }
  }, [patAlertData, patientId]);

  const handlePhoneNoteAccess = (id, patId) => {
    setPhoneNoteViewPopup({ status: true, soapId: id, patId: patId });
  };
  const handlePhoneNoteChange = (id, patId) => {
    setPhoneNotePopup({ status: true, soapId: id, patId: patId });
  };

  return (
    <>
      {(appId === undefined && (
        <div className="c-mid-bdy-blk">
          <div
            className="appt-loc-val"
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              fontSize: '14px',
              fontWeight: 'bold',
            }}
          >
            <div
              className=""
              style={{
                textAlign: 'right',
                width: '45%',
              }}
            >
              <input
                type="checkbox"
                className=""
                value={allOpen}
                checked={allOpen}
                onChange={(e) => setAllOpen(e.target.checked ? 1 : 0)}
              />
              <span className="clear-left10">Open</span>
            </div>
            <div
              className=""
              style={{
                textAlign: 'left',
                width: '40%',
                marginLeft: '5%',
              }}
            >
              <input
                type="checkbox"
                className=""
                value={allSigned}
                checked={allSigned}
                onChange={(e) => setAllSigned(e.target.checked ? 1 : 0)}
              />
              <span className="clear-left10">Signed</span>
            </div>
          </div>
          <div className="t-plan-hdr">
            <span className="t-plan-lbl pc-col-2">
              <span className="bold">DOS </span>
              <input
                type="search"
                className="main-search"
                placeholder="mm-dd-yyyy"
                value={dosSerch}
                onChange={(e) => setDosSerch(e.target.value)}
              />
            </span>
            <span className="t-plan-lbl pc-col-4">
              <span className="bold">Visit Type.</span>
              <select
                className="appt-col-slct"
                value={tovSerch}
                onChange={(e) => setTovSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.allTov &&
                  allData?.allTov.map((visitVal, idx) => {
                    return (
                      <option key={idx} value={visitVal?.id}>
                        {visitVal?.visit_type}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-2">
              <span className="bold">Note</span>
              <select
                className="appt-col-slct"
                value={noteStSerch}
                onChange={(e) => setNoteStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.noteStatus &&
                  allData?.noteStatus.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Provider</span>
              <select
                className="appt-col-slct"
                value={provId}
                onChange={(e) => setProvIdSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.allResource &&
                  allData?.allResource.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-4">
              <span className="bold">Provider Sign.</span>
              <select
                className="appt-col-slct"
                value={provSignSt}
                onChange={(e) => setProvStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.signStatus &&
                  allData?.signStatus.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Co-Signer</span>
              <select
                className="appt-col-slct"
                value={coSigner}
                onChange={(e) => setCoProvIdSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.allResource &&
                  allData?.allResource.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.resName}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-4">
              <span className="bold">Co-Signer Sign.</span>
              <select
                className="appt-col-slct"
                value={coSignerSt}
                onChange={(e) => setCoProvStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.signStatus &&
                  allData?.signStatus.map((note, idx) => {
                    return (
                      <option key={idx} value={note?.id}>
                        {note?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Action</span>
              <select
                className="appt-col-slct"
                value={actionSt}
                onChange={(e) => setActionStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.actionFilter &&
                  allData?.actionFilter.map((filter, idx) => {
                    return (
                      <option key={idx} value={filter?.id}>
                        {filter?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Payor</span>
              <select className="appt-col-slct">
                <option value="">All Payor</option>
                {allData?.allInsurance &&
                  allData?.allInsurance.map((ins, idx) => {
                    return (
                      <option key={idx} value={ins?.id}>
                        {ins?.insName}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Service Code</span>
              <input
                type="search"
                className="main-search"
                placeholder="Search Service Code..."
                value={serviceCode}
                onChange={(e) => setServiceCodeSerch(e.target.value)}
              />
            </span>
            <span className="t-plan-lbl pc-col-2 bold">Dx</span>

            <span className="t-plan-lbl pc-col-1">
              <span className="bold">Billing</span>
              <select
                className="appt-col-slct"
                value={billSt}
                onChange={(e) => setBillStSerch(e.target.value)}
              >
                <option value="">All</option>
                {allData?.billStatus &&
                  allData?.billStatus.map((bill, idx) => {
                    return (
                      <option key={idx} value={bill?.id}>
                        {bill?.val}
                      </option>
                    );
                  })}
              </select>
            </span>
            <span className="t-plan-lbl pc-col-2 bold">$</span>
          </div>
          {allData?.counNote && allData?.counNote.length > 0 ? (
            <div className="t-plan-bdy">
              {allData?.counNote.map((item, idx) => {
                const ltClass = idx % 2 === 0 ? '' : 'alt-rw';
                return (
                  <div key={idx} className={`t-plan-bdy-rw ${ltClass}`}>
                    <span className="t-plan-lbl pc-col-2">{item?.dos}</span>
                    <span className="t-plan-lbl pc-col-4">{item?.tov}</span>
                    <span className="t-plan-lbl pc-col-2 maroon">
                      {item?.noteSt}
                    </span>
                    <span className="t-plan-lbl pc-col-1">
                      {item?.providerName}
                    </span>
                    <span className="t-plan-lbl pc-col-4 maroon">
                      {item?.signSt}
                    </span>
                    <span className="t-plan-lbl pc-col-1">
                      {item?.providerName === item?.coSigner
                        ? ''
                        : item?.coSigner}
                    </span>
                    <span className="t-plan-lbl pc-col-4 maroon ">
                      {item?.providerName === item?.coSigner
                        ? ''
                        : item?.coSignSt}
                    </span>
                    <span className="t-plan-lbl pc-col-1">
                      {(() => {
                        if (
                          item?.note_type === '0' ||
                          item?.note_type === '2'
                        ) {
                          return (
                            <span
                              className=""
                              onClick={() =>
                                handleSoapPopUpOpen(
                                  item?.soapId,
                                  item?.appointmentId,
                                  item?.actionLabel,
                                  item?.visitId
                                )
                              }
                            >
                              <Link>{item?.actionLabel}</Link>
                            </span>
                          );
                        } else if (item?.tov === 'Phone Note' || item?.tov === 'Discharge Note' || item?.tov === 'Clinical Note') {
                          return (
                            <>
                              <span
                                onClick={() =>
                                  handlePhoneNoteAccess(
                                    item?.soapId,
                                    item?.user_id
                                  )
                                }
                              >
                                <Link>Access</Link>
                              </span>{' '}
                              |{' '}
                              <span
                                onClick={() =>
                                  handlePhoneNoteChange(
                                    item?.soapId,
                                    item?.user_id
                                  )
                                }
                              >
                                <Link>Change</Link>
                              </span>
                            </>
                          );
                        } else {
                          return (
                            <span
                              className=""
                              onClick={() =>
                                handleCounPopUpOpen(
                                  item?.soapId,
                                  item?.appointmentId,
                                  item?.actionLabel,
                                  item?.visitId
                                )
                              }
                            >
                              <Link>{item?.actionLabel}</Link>
                            </span>
                          );
                        }
                      })()}

                      {/* {item?.note_type === '0' || item?.note_type === '2' ? (
                        <span
                          className=""
                          onClick={() =>
                            handleSoapPopUpOpen(
                              item?.soapId,
                              item?.appointmentId,
                              item?.actionLabel
                            )
                          }
                        >
                          <Link>{item?.actionLabel}</Link>
                        </span>
                      ) : (
                        <span
                          className=""
                          onClick={() =>
                            handleCounPopUpOpen(
                              item?.soapId,
                              item?.appointmentId,
                              item?.actionLabel,
                              item?.visitId
                            )
                          }
                        >
                          <Link>{item?.actionLabel}</Link>
                        </span>
                      )} */}
                    </span>
                    <span className="t-plan-lbl pc-col-1">{item?.payor}</span>
                    <span className="t-plan-lbl pc-col-1">
                      {item?.serviceCode}
                    </span>
                    <span className="t-plan-lbl pc-col-2">{item?.dx}</span>
                    <span className="t-plan-lbl pc-col-1">
                      {item?.billingSt}
                    </span>
                    <span className="t-plan-lbl pc-col-2">{item?.amt}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="no-appoinmnts-here">No Pt. Information !!</p>
          )}
          {patProgViewPopup && (
            <PatientPrgressReport
              soapId={soapId}
              patientId={patientId}
              appId={appointmentId}
              visit_id={visit_id}
              close={() => setPatProgViewPopup(false)}
              handleReload={handleReload}
            />
          )}
          {phoneNotePopup.status && (
            <AddNote
              patId={phoneNotePopup?.patId}
              soapId={phoneNotePopup?.soapId}
              handleClose={() =>
                setPhoneNotePopup({ ...phoneNotePopup, status: false })
              }
            />
          )}
          {phoneNoteViewPopup.status && (
            <ViewPhoneNote
              patId={phoneNoteViewPopup?.patId}
              soapId={phoneNoteViewPopup?.soapId}
              handleClose={() =>
                setPhoneNoteViewPopup({ ...phoneNoteViewPopup, status: false })
              }
              handleChange={() => {
                setPhoneNoteViewPopup({ ...phoneNoteViewPopup, status: false });
                handlePhoneNoteChange(
                  phoneNoteViewPopup?.soapId,
                  phoneNoteViewPopup?.patId
                );
              }}
            />
          )}
          {alertPopup && (
            <ViewAlertPopup
              alertData={patAlertData}
              patientId={patientId}
              close={() => setAlertPopup(false)}
            />
          )}
        </div>
      )) ||
        (appId && (
          <CounselingNoteEdit
            patientId={patientId}
            appId={appId}
            handleReloadCf={handleReload}
            editMode={flag}
            vid={visitId}
          />
        ))}
    </>
  );
}

export default PatientCounselingNote;
